var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCurveRightUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-curve-right-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.4883 3.5L17.9166 7.92834M17.9166 7.92834L13.4883 12.3567M17.9166 7.92834L7.91663 7.92834C5.70749 7.92834 3.91663 9.7192 3.91663 11.9283L3.91663 16.5",
    stroke: "#2D2B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCurveRightUp);
export default __webpack_public_path__ + "static/media/arrow-curve-right-up.8642b49f26ab21149c1d4f22c967fdf0.svg";
export { ForwardRef as ReactComponent };